// extracted by mini-css-extract-plugin
export default {"NotificationButton":"ReferralsContent_NotificationButton__8S8ro"};